import React, { useState } from "react";
import styles from "../../Application.module.scss";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import Surcharge from "./Pricing/Surcharge";
import OtherFees from "./Pricing/OtherFees";
import Tiered from "./Pricing/Tiered";
import DualPricing from "./Pricing/DualPricing";
import FlatRate from "./Pricing/FlatRate";
import ICPlus from "./Pricing/ICPlus";
import useCommonStore from "../../../../stores/common";

function Pricing({ appData }) {
  const expandAppDetails = useCommonStore((state) => state.expandDetails);
  const [expended, setExpended] = useState(false);
  const toggleExpend = () => {
    setExpended(!expended);
  };

  const renderPricing = () => {
    if (appData.qualifiedtype === "tiered") return <Tiered appData={appData} />;
    if (appData.qualifiedtype === "surcharge")
      return <Surcharge appData={appData} />;
    if (appData.qualifiedtype === "dual_pricing")
      return <DualPricing appData={appData} />;
    if (appData.qualifiedtype === "flat_rate")
      return <FlatRate appData={appData} />;
    if (appData.qualifiedtype === "ic_plus")
      return <ICPlus appData={appData} />;
  };

  return (
    <div
      className={`${styles.pricing} ${expandAppDetails ? styles.expanded : ""}`}
    >
      <div className={styles.head}>
        <ButtonIcon onClick={toggleExpend}>
          <svg
            className={expended ? styles.expended : ""}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M17.0306 12.5307L9.53062 20.0307C9.46093 20.1004 9.37821 20.1556 9.28716 20.1933C9.19612 20.2311 9.09854 20.2505 8.99999 20.2505C8.90144 20.2505 8.80386 20.2311 8.71282 20.1933C8.62177 20.1556 8.53905 20.1004 8.46936 20.0307C8.39968 19.961 8.34441 19.8783 8.30669 19.7872C8.26898 19.6962 8.24957 19.5986 8.24957 19.5001C8.24957 19.4015 8.26898 19.3039 8.30669 19.2129C8.34441 19.1218 8.39968 19.0391 8.46936 18.9694L15.4397 12.0001L8.46936 5.03068C8.32863 4.88995 8.24957 4.69907 8.24957 4.50005C8.24957 4.30103 8.32863 4.11016 8.46936 3.96943C8.61009 3.8287 8.80097 3.74963 8.99999 3.74963C9.19901 3.74963 9.38988 3.8287 9.53062 3.96943L17.0306 11.4694C17.1003 11.5391 17.1557 11.6218 17.1934 11.7128C17.2312 11.8039 17.2506 11.9015 17.2506 12.0001C17.2506 12.0986 17.2312 12.1962 17.1934 12.2873C17.1557 12.3783 17.1003 12.461 17.0306 12.5307Z"
              fill="#3A383F"
            />
          </svg>
        </ButtonIcon>
        <h5>Pricing</h5>
      </div>

      <div
        className={`${styles.body} ${expended ? styles.body_expended : ""} ${expandAppDetails ? styles.app_details_expanded : ""}`}
      >
        {expended && (
          <>
            {renderPricing()}
            <OtherFees appData={appData} />
            {/* VAR sheet */}
            {/* <div>
              <HeadingWithLine text="VAR sheet" />
              <ul>
                <li>
                  <div>
                    <p>Reprogram equipment</p>
                    <p>QI890</p>
                  </div>
                </li>
              </ul>
            </div> */}
          </>
        )}
      </div>
    </div>
  );
}

export default Pricing;
